document.addEventListener('alpine:init', () => {
  Alpine.data('xCookieBanner', (delay) => ({
    show: false,
    init() {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          if (error) console.warn('Consent API:', error);
          document.dispatchEvent(new CustomEvent('eurus:customer-privacy:loaded'));
          if (error) return;

          const cp = window.Shopify.customerPrivacy;
          if (cp.getTrackingConsent() === 'no_interaction') {
            setTimeout(() => (this.show = true), delay * 1000);
          }
        }
      );
    },
    setConsent(allowed) {
      const cp = window.Shopify.customerPrivacy;
      if (!cp) return;
      cp.setTrackingConsent(
        { analytics: allowed, marketing: allowed, preferences: allowed },
        () => {}
      );
      this.show = false;
    },
    handleAccept() { this.setConsent(true); },
    handleDecline() { this.setConsent(false); }
  }));
});